(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slop-cannon-launch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cannon-hero-carousel')) {
  customElements.define('cannon-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const track = this.querySelector('.cannon-launch__track');
      const slides = [...this.querySelectorAll('.cannon-launch__slide')];
      const position = this.querySelector('.cannon-launch__position');
      const buttons = [...this.querySelectorAll('[data-direction]')];
      const update = () => {
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        position.textContent = (index + 1) + ' / ' + slides.length;
        buttons[0].disabled = index === 0;
        buttons[1].disabled = index === slides.length - 1;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        track.scrollBy({left: Number(button.dataset.direction) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive: true});
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.cannon-launch__slide');
        if (slide) track.scrollTo({left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'instant'});
      });
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
